export function hideAndroidTopBar() {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].setTopBar &&
    window['mylo_android'].setTopBar(false);
}

export function useAndroidShowTopBar() {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].setTopBar &&
    window['mylo_android'].setTopBar(true);
}

// set native header title text
export function useAndroidSetTitle(title) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].setTitle &&
    window['mylo_android'].setTitle(title);
}

export function enableAndroidBack(bool) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].enableBack &&
    window['mylo_android'].enableBack(bool);
}

export function androidDisablePullRefresh() {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].enableScrollToRefresh &&
    window['mylo_android'].enableScrollToRefresh(false);
}

export function hideAndroidBottomBar() {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].setBottomBarVisibility &&
    window['mylo_android'].setBottomBarVisibility(false);
}

export function androidCanWebViewBack() {
  // Execute android's webGoBack function
  window &&
    window['mylo_android'] &&
    window['mylo_android'].webGoBack &&
    window['mylo_android'].webGoBack();
  // return weather android's webGoBack function was available
  return window && window['mylo_android'] && window['mylo_android'].webGoBack
    ? true
    : false;
}

/*** This function is responsible to fire android native firebase events*
 *  @param {*} deeplink : {string} - category name of the event*
 *  @param {*} deeplinkUrl : {string} - event params object*/
export function isAndroidOpenDeeplink(deeplink, deeplinkUrl) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].openDeeplink &&
    window['mylo_android'].openDeeplink(deeplink, deeplinkUrl);
}

/**
 * To request location permission to user in Ios
 */
export function requestOrGrantLocationPermission() {
  if (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].requestOrGrantLocationPermission
  ) {
    return window['mylo_android'].requestOrGrantLocationPermission();
  } else {
    return false;
  }
}

export function clearNuxData() {
  if (window && window['mylo_android'] && window['mylo_android'].clearNuxData) {
    window['mylo_android']?.clearNuxData();
  }
}

export function androidClickAddToCart(str) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].addToCart &&
    window['mylo_android'].addToCart(str);
}

export function androidClickBuyNow(str) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].buyNow &&
    window['mylo_android'].buyNow(str);
}

export function androidGetUserId() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].getUserId &&
    window['mylo_android'].getUserId()
  );
}

export function androidIsAppUser() {
  if (typeof window != 'undefined')
    return window &&
      window['mylo_android'] &&
      window['mylo_android'].getUserData
      ? true
      : false;
}

export function getAndroidAppPageInstance() {
  if (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].getAndroidPageInstance
  ) {
    return window['mylo_android'].getAndroidPageInstance();
  } else {
    return '';
  }
}

export function checkAndroidStopLoader() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].removeLoader &&
    window['mylo_android'].removeLoader()
  );
}

export function useAndroidFetchUserDetails() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].getUserData &&
    window['mylo_android'].getUserData()
  );
}

export function useAndroidSetCart() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].setCart &&
    window['mylo_android'].setCart('false', 0, '')
  );
}

export function useAndroidOpenChromeTab(url) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].openChromeTab &&
    window['mylo_android'].openChromeTab(url);
}

export function useAndroidOpenDeeplinkNew(
  deeplink,
  deeplinkUrl,
  order_ids = '',
  address_id = null,
) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].openDeeplinkNew &&
    window['mylo_android'].openDeeplinkNew(
      deeplink,
      deeplinkUrl,
      order_ids,
      address_id,
    );
}

export function useAndroidFireAnalyticsEvents(category, firebaseParams) {
  window &&
    window['mylo_android'] &&
    window['mylo_android'].logFirebaseEvent &&
    window['mylo_android'].logFirebaseEvent(
      category,
      JSON.stringify(firebaseParams),
    );
}

export function useAndroidGetAppVersion() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].getAppVersion &&
    window['mylo_android'].getAppVersion()
  );
}

export function useAndroidShowToast(text) {
  if (typeof window != 'undefined') {
    return (
      window &&
      window['mylo_android'] &&
      window['mylo_android'].showToast &&
      window['mylo_android'].showToast(text)
    );
  }
}

export function useExitWebView() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].exitWebView &&
    window['mylo_android'].exitWebView()
  );
}

export function useOpenUploadMedia() {
  return (
    window &&
    window['mylo_android'] &&
    window['mylo_android'].openUploadMedia &&
    window['mylo_android'].openUploadMedia()
  );
}
